import React from 'react'

export default function TabPanel ({ children, ...props }) {
  return (
    <div className='TabPanel' {...props}>
      {children}
    </div>
  )
}
